/**
 * Coffee collection helpers:
 * - Quick Add via /cart/add.js
 * - Collection filter panel (process / roast / decaf)
 */
(function () {
  'use strict';

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(body),
      credentials: 'same-origin',
    }).then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed');
      return res.json();
    });
  }

  function refreshCartCount() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
        if (count === null) return;
        document.querySelectorAll('[data-cart-count], .cart-count, .Header__CartCount, .header__cart-count').forEach(function (el) {
          el.textContent = String(count);
          el.setAttribute('data-cart-count', String(count));
        });
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', { detail: { cart: cart } })
        );
      })
      .catch(function () {});
  }

  function bindQuickAdd(root) {
    (root || document).querySelectorAll('[data-hp-quick-add]').forEach(function (form) {
      if (form.getAttribute('data-hp-quick-bound') === 'true') return;
      form.setAttribute('data-hp-quick-bound', 'true');

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var button = form.querySelector('[type="submit"]');
        var label = form.querySelector('[data-hp-quick-label]');
        var idInput = form.querySelector('input[name="id"]');
        if (!idInput || !idInput.value) return;

        var previous = label ? label.textContent : '';
        if (button) button.disabled = true;
        if (label) label.textContent = 'Adding…';

        postJSON(form.getAttribute('action') || '/cart/add.js', {
          id: Number(idInput.value),
          quantity: 1,
        })
          .then(function () {
            if (label) label.textContent = 'Added';
            refreshCartCount();
            window.setTimeout(function () {
              if (label) label.textContent = previous || 'Quick add +';
              if (button) button.disabled = false;
            }, 1400);
          })
          .catch(function () {
            if (label) label.textContent = 'Try again';
            if (button) button.disabled = false;
            window.setTimeout(function () {
              if (label) label.textContent = previous || 'Quick add +';
            }, 1600);
          });
      });
    });
  }

  function cards() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-hp-coffee-card]'));
  }

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\+/g, '')
      .replace(/\s+/g, '-')
      .replace(/_+/g, '-');
  }

  function applyFilter(raw) {
    var active = normalize(raw) || 'all';
    var list = cards();
    var visible = 0;

    list.forEach(function (card) {
      var show = true;
      if (active === 'all') {
        show = true;
      } else if (active === 'decaf') {
        show = card.getAttribute('data-decaf') === 'true';
      } else if (active.indexOf('process:') === 0) {
        show = normalize(card.getAttribute('data-process')) === active.replace('process:', '');
      } else if (active.indexOf('roast:') === 0) {
        show = normalize(card.getAttribute('data-roast')) === active.replace('roast:', '');
      } else {
        var profiles = normalize(card.getAttribute('data-profiles'));
        show = profiles.split(/\s+/).indexOf(active) !== -1;
      }

      card.hidden = !show;
      card.classList.toggle('is-hidden', !show);
      if (show) visible += 1;
    });

    document.querySelectorAll('[data-hp-coffee-filter]').forEach(function (btn) {
      var value = normalize(btn.getAttribute('data-hp-coffee-filter'));
      var isActive = value === active;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    document.querySelectorAll('[data-hp-coffee-empty]').forEach(function (el) {
      el.hidden = visible > 0;
    });
  }

  function bindFilters(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-hp-coffee-filter]').forEach(function (btn) {
      if (btn.getAttribute('data-hp-filter-bound') === 'true') return;
      btn.setAttribute('data-hp-filter-bound', 'true');

      btn.addEventListener('click', function () {
        applyFilter(btn.getAttribute('data-hp-coffee-filter'));
      });
    });

    scope.querySelectorAll('[data-hp-coffee-filter-toggle]').forEach(function (toggle) {
      if (toggle.getAttribute('data-hp-filter-toggle-bound') === 'true') return;
      toggle.setAttribute('data-hp-filter-toggle-bound', 'true');

      var panelId = toggle.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) {
        panel = toggle.closest('.hp-coffee-grid')
          ? toggle.closest('.hp-coffee-grid').querySelector('[data-hp-coffee-filter-panel]')
          : null;
      }
      if (!panel) return;

      toggle.addEventListener('click', function () {
        var open = panel.hasAttribute('hidden');
        if (open) {
          panel.removeAttribute('hidden');
          toggle.setAttribute('aria-expanded', 'true');
          toggle.classList.add('is-open');
        } else {
          panel.setAttribute('hidden', '');
          toggle.setAttribute('aria-expanded', 'false');
          toggle.classList.remove('is-open');
        }
      });
    });

    applyFilter('all');
  }

  function init(root) {
    bindQuickAdd(root);
    bindFilters(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
